import React from 'react';
import { Stack, Text } from '@moda/om';
import ReturnsIcon from '@moda/icons/returns-16';
import { OrderItemReturnPolicy } from '../../constants';

interface Props {
  returnPolicyCode: OrderItemReturnPolicy;
}

export const LineItemReturnPolicyHeader: React.FC<Props> = () => (
  <Stack
    className="LineItemReturnPolicyHeader"
    direction="horizontal"
    space={2}
    alignItems="center"
  >
    <ReturnsIcon />
    <Text treatment="body1"> Return Policy </Text>
  </Stack>
);
